module.exports = __webpack_public_path__ + "static/sausage-roll-e130797ff46f81139d04a2134daf6359.jpg";